<template>
  <div>
    <a-card :bordered="false" class="header-solid h-full mb-50" :bodyStyle="{ paddingTop: '12px' }" style="background: transparent; box-shadow: none;">
      <template #title>
        <a-row>
          <a-col :xs="24" :sm="24" :md="20" :lg="20" :xl="20">
            <h6 class="font-web f-18"><a @click="gotoMainType" class="mr-5">
              <a-icon type="arrow-left" /></a>&nbsp;แบบฟอร์มคำขออนุมัติ <span class="ml-5 text-danger font-weight-bold">อบรม / สัมมนา / ประชุม / ดูงาน</span>
            </h6>
            <p class="form-sub-title font-web ml-20">&nbsp;&nbsp;Training / Seminar / Conference / Educational Visit Request Form</p>
          </a-col>
        </a-row>
      </template>
      <!-- form -->
      <a-row :gutter="24" type="flex" align="stretch">
        <a-col :xs="24" :sm="24" :md="0" :lg="1" :xl="1"></a-col>
        <a-col :xs="24" :sm="24" :md="8" :lg="7" :xl="7" class="h-full">
          <historyRequest :dataRequest="dataHistory" textHead="Training / Seminar / Conference / Educational Visit" :loadingList="loadingList" class="h-full" />
        </a-col>
        <a-col :xs="24" :sm="24" :md="16" :lg="15" :xl="15">
          <div class="form-container">
            <a-form class="font-web" :layout="'horizontal'">
            <a-descriptions bordered title="" size="small">
              <a-descriptions-item :span="3">
                <div slot="label">
                  <h6 class="mt-0 mb-0 font-web">
                    ประเภท <span class="text-danger">*</span>
                  </h6>
                </div>
                <a-radio-group v-model="formSerminar.seminar_type" button-style="solid">
                  <a-radio-button v-for="(r, index) in [
                    'training',
                    'seminar',
                    'educational_visit',
                    'other',
                  ]" :key="'r' + index" :value="r">
                    <p class="mt-0 mb-0 font-web">{{ r }}</p>
                  </a-radio-button>
                </a-radio-group>
              </a-descriptions-item>
              <a-descriptions-item span="3">
                <div slot="label">
                  <h6 class="mt-0 mb-0 font-web">
                    เลือกวันที่เริ่มเดินทางไปอบรม
                    <span class="text-danger">*</span>
                  </h6>
                </div>
                <a-date-picker v-model="formSerminar.selected_date" :disabled-date="disabledWorkDate" format="YYYY-MM-DD"
                  placeholder="Start" :mode="['date']" @openChange="handleStartOpenChange" />
              </a-descriptions-item>
              <a-descriptions-item span="3">
                <div slot="label">
                  <h6 class="mt-0 mb-0 font-web">
                    ถึงวันที่
                    <span class="text-danger">*</span>
                  </h6>
                </div>
                <a-date-picker :mode="['date']" v-model="formSerminar.move_to_date" :disabled-date="disabledHolidayDate"
                  format="YYYY-MM-DD" placeholder="End" :open="endOpen" :disabled="formSerminar.selected_date === null"
                  @openChange="handleEndOpenChange" />
              </a-descriptions-item>
              <a-descriptions-item span="3">
                <div slot="label">
                  <h6 class="mt-0 mb-0 font-web">
                    รวมไปอบรม
                    <span class="text-danger">*</span>
                  </h6>
                </div>
                <a-input-number type="number" v-model="formSerminar.serminar_amount" :disabled="formSerminar.selected_date === '' || formSerminar.move_to_date === ''
                  " />
              </a-descriptions-item>
            </a-descriptions>

            <h6 class="mt-20 mb-10 font-web">
              รายละเอียดการขอไปอบรม <span class="text-danger">*</span>
            </h6>
            <a-form-item>
              <a-textarea placeholder="" :auto-size="{ minRows: 3, maxRows: 5 }" v-model="formSerminar.detail" />
            </a-form-item>

            <h6 class="mt-0 mb-5 font-web">
              Upload เอกสารที่เกี่ยวกับการอบรม :
            </h6>
            <a-upload :file-list="fileList" :remove="handleRemove" :before-upload="beforeUpload" :multiple="false"
              v-model="formSerminar.file_backup" class="mb-5" accept="image/*;capture=camera">
              <a-button> <a-icon type="upload" /> Select File </a-button>
            </a-upload>

            <div class="mt-20 mb-20" v-if="this.$store.state.role.RulesUser.permissions.indexOf(
              `IC-HRI:chief`
            ) >= 0
              ">
              <h6 class="mt-0 mb-5 font-web">
                Upload documents ( For chief to hr ) :<span class="text-danger">*</span>
              </h6>
              <a-upload :file-list="fileChiefList" :remove="handleChiefRemove" :before-upload="beforeChiefUpload"
                :multiple="false" v-model="formSerminar.chief_backup" class="mb-5" accept="image/*;capture=camera">
                <a-button> <a-icon type="upload" /> Select File </a-button>
              </a-upload>
            </div>
            <br /><br />

            <a-form-item class="mt-3">
              <a-row>
                <a-col :span="8">
                  <a-button type="danger" @click="clearForm">
                    <b>ยกเลิกการขอ</b>
                  </a-button>
                </a-col>
                <a-col :style="{ textAlign: 'right' }" :span="8" :offset="8">
                  <a-button type="primary" class="font-web pa-10" @click="dialogConfirm = true" size="lg"
                    style="font-size: 14px" :disabled="formSerminar.selected_date === null ||
                      formSerminar.move_to_date === null
                      ">
                    ส่งคำขออนุมัติ
                  </a-button>
                </a-col>
              </a-row>
            </a-form-item>
          </a-form>
          </div>
        </a-col>
      </a-row>
    </a-card>
    <!-- dialog -->
    <a-modal title="Confirm" :visible="dialogConfirm" @ok="submitRequest" @cancel="clearForm">
      <p v-if="boxFlexError.length === 0" class="mt-10 mb-20">
        Are you sure to Submit ?
      </p>
      <a-spin v-if="loading" tip="Loading..."></a-spin>
      <div v-if="boxFlexError.length !== 0">
        <a-alert :message="`Error The date you selected cannot be redeemed ::`" type="error" show-icon>
          <div slot="description">
            <span v-if="boxFlexError[0].msg === undefined">
              {{ boxFlexError[0] }}
            </span>
            <span v-else>{{ boxFlexError[0].msg }}</span>
          </div>
        </a-alert>
      </div>
    </a-modal>
  </div>
</template>

<script>
const form = {
  selected_date: null,
  move_to_date: null,
  serminar_amount: 0,
  detail: "",
  file_backup: null,
  seminar_type: "",
  chief_backup: null,
};
import { hriRequestMixin } from "@/mixins/hriRequestMixin";
import historyRequest from './history_request.vue';
export default {
  mixins: [hriRequestMixin],
  components: {
    historyRequest
  },
  data() {
    return {
      dialogConfirm: false,
      // form
      formSerminar: { ...form },
      loading: false,
      // config
      mode1: "time",
      dataDayNotFlex: [],
      // error
      boxFlexError: [],
      // file upload - handled by mixin
      uploading: false,
      // 
      dataHistory: [],
      loadingList: false,
    };
  },
  computed: {
    dateVal() {
      const { selected_date, move_to_date } = this.formSerminar;
      return {
        selected_date,
        move_to_date,
      };
    },
  },
  watch: {
    dateVal: {
      handler(val) {
        this.formSerminar.serminar_amount = 0;
        if (val.selected_date === "" || val.selected_date === null) {
          this.formSerminar.move_to_date = "";
        }
        if (
          val.selected_date !== "" &&
          val.selected_date !== null &&
          val.move_to_date !== "" &&
          val.move_to_date !== null
        ) {
          this.setCalTotalDate(val.selected_date, val.move_to_date);
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.stBudgetYear()
    this.getAllRequest()
  },
  methods: {
    async getAllRequest() {
      await this.loadRequestHistory('/hri/seminar-request/', { start: 'timestart', end: 'timeend' });
    },
    // func. write
    disabledWorkDate(date) {
      if(this.stYear.includes(Number.parseInt(this.moment(date._d).format("YYYY")))){
        if(this.stMonthBud.includes(`${this.moment(date._d).format("YYYY-MM")}`)){
          return false
        }else{
          return true
        }
      }else{
        return true
      }
    },
    disabledEndDate(endValue) {
      const startValue = this.formSerminar.selected_date;
      if (!endValue || !startValue) {
        return false;
      }
      return formSerminar.selected_date.valueOf() >= endValue.valueOf();
    },
    disabledHolidayDate(date) {
      const startValue = this.formSerminar.selected_date;
      return startValue.valueOf() >= date.valueOf();
    },
    clearForm() {
      this.dialogConfirm = false;
      this.formSerminar = { ...form };
      this.boxFlexError = [];
    },
    setCalTotalDate(a, b) {
      let start = this.moment(a);
      let end = this.moment(b);
      this.formSerminar.serminar_amount = 0;
      let diff = end.diff(start, "days") + 1;
      this.formSerminar.serminar_amount = diff;
    },
    async submitRequest() {
      this.boxFlexError = [];
      this.loading = true;
      const sendData = new FormData();
      sendData.append(
        "start_date",
        this.moment(this.formSerminar.selected_date).format("YYYY-MM-DD")
      );
      sendData.append(
        "end_date",
        this.moment(this.formSerminar.move_to_date).format("YYYY-MM-DD")
      );
      sendData.append("seminar_type", this.formSerminar.seminar_type);
      sendData.append("seminar_amount", this.formSerminar.serminar_amount);
      sendData.append("file_backup", this.formSerminar.file_backup);
      sendData.append("remark", this.formSerminar.detail);
      if (
        this.$store.state.role.RulesUser.permissions.indexOf(`IC-HRI:chief`) >= 0
      ) {
        sendData.append("chief_backup", this.formSerminar.cheifFile);
      }
      try {
        const response = await this.$http.post(
          "/hri/seminar-request/",
          sendData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );
        if (response.status === 201) {
          this.loading = false;
          this.clearForm();
          this.$success({
            title: "This is a success message",
            content: (
              <div>
                <p class="mt-0 mb-0">Success : send request Training / Seminar / Conference / Educational Visit</p>
                <p class="font-web mt-0 mb-0">
                  (ข้อมูลของท่านถูกบันทึกเรียบร้อย)
                </p>
              </div>
            ),
          });
          this.$router
            .push({
              path: "/hri/"
            });
        } else {
          const error = new Error('Request Failed');
          error.response = response;
          throw error;
        }
      } catch (error) {
        this.$notification.open({
          style: {
            backgroundColor: "#ff1919",
            color: "#ffffff",
          },
          message: function (h) {
            return h("div", [
              h(
                "strong",
                { class: "font-web" },
                `Error ${error.response.status}`
              ),
            ]);
          },
          description: `Proble issue connect api : /hri/seminar-request/`,
        });
        this.boxFlexError.push(error.response.data);
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.f-14 {
  font-size: 14px;
}

.spin-content {
  border: 1px solid #91d5ff;
  background-color: #e6f7ff;
  padding: 30px;
}

.form-sub-title {
  font-size: 12px;
  margin-top: 5px;
  margin-bottom: 0px;
}

.form-container {
  border: 1px solid #e8e8e8;
  border-radius: 12px;
  padding: 24px;
  height: 100%;
  background: #ffffff;
}

.h-full {
  height: 100%;
}
</style>